//基础组件
//1.布局
import Layout from './packages/basicElement/layout/Layout.vue';
import Toolbar from './packages/basicElement/layout/Toolbar.vue';
import ListLayout from './packages/basicElement/layout/ListLayout.vue';
import FilterHidePanel from './packages/basicElement/layout/FilterHidePanel.vue';
import LmsDialog from './packages/basicElement/dialog/LmsDialog.vue';
import VSplit from './packages/basicElement/SplitLine/VSplit.vue';
import Ribbon from './packages/basicElement/ribbon/Ribbon.vue';

//2.控件
import DateBox from './packages/basicElement/datebox/dateTimeBox.vue';
import SearchInput from './packages/basicElement/searchInput/SearchInput.vue';
import UE from './packages/basicElement/ue/UE.vue';
import CropUpload from './packages/basicElement/upload/CropUpload.vue'
//3.数据
import BaseTable from './packages/basicElement/table/BaseTable.vue';
import PageTable from './packages/basicElement/table/PageTable.vue';

//业务组件
import BTable from './packages/businessElement/BTable/BTable.vue'
import BPageTable from './packages/businessElement/BPageTable/BPageTable.vue'


const components = [
  Toolbar,
  Layout,
  ListLayout,
  FilterHidePanel,
  DateBox,
  SearchInput,
  BaseTable,
  PageTable,
  BPageTable,
  BTable,
  UE,
  LmsDialog,
  CropUpload,
  VSplit,
  Ribbon
];

//安装组件
const install = function (Vue, opts = {}) {
  /* istanbul ignore if */
  if (install.installed) return;

  components.map(component => {
    Vue.component(component.name, component);
  });

  //dialog方法
  Vue.prototype.$dialog = {
    open(component, args) {
      return new Promise((resolve, reject) => {

        let Dialog = Vue.extend(component)

        var $vm = new Dialog({
          el: document.createElement('div')
        })

        var node = document.body.appendChild($vm.$el)

        $vm.open(args).then(result => {
          if (resolve) {
            resolve(result);
          }
          node.remove();
          $vm.$destroy();
        }, () => {
          // if (reject) {
          //   try {
          //     reject();
          //   } catch (e) {
          //
          //   }
          // }
          node.remove();
          $vm.$destroy();
        });
      });
    }
  }
};

if (typeof window !== 'undefined' && window.vue) {
  install(window.vue);
}
;

export default {
  version: '0.0.1',
  install,
  ...components
};



// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/index.js